<template>
    <div class="settings-layout">
        <v-toolbar density="compact" flat color="#fafafa" class="mt-0 toolbar-settings">
            <v-toolbar-title class="text-body-2 ml-0 pl-0 overflow-x-visible">
                <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-if="showCloseButton" icon size="small" @click="$emit('close')">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>
        <div class="settings-grid">
            <div class="settings-sidebar">
                <v-list
                    v-model:selected="selectedIndex"
                    lines="one"
                    density="compact"
                    mandatory
                    nav
                    open-strategy="single"
                    class="settings-list"
                >
                    <v-list-item
                        v-for="(item, index) in navigationItems"
                        :key="index"
                        :value="index"
                    >
                        <v-icon start>{{ item.icon || 'mdi-chevron-right' }}</v-icon>
                        {{ item.title }}
                    </v-list-item>
                </v-list>
            </div>
            <div class="settings-content">
                <div class="settings-component">
                    <component :is="currentComponent"></component>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
    componentName: {
        type: String,
        required: true,
    },
    componentTitle: {
        type: String,
        required: true,
    },
    navigationItems: {
        type: Array,
        required: true,
        validator: (items) => {
            return items.every(
                (item) =>
                    typeof item.title === 'string' &&
                    (!item.icon || typeof item.icon === 'string') &&
                    item.component,
            );
        },
    },
    showCloseButton: {
        type: Boolean,
        default: true,
    },
});

const emit = defineEmits(['close']);

const selectedIndex = ref(0);

const currentComponent = computed(() => {
    return props.navigationItems[selectedIndex.value]?.component;
});

const breadcrumbs = computed(() => {
    return [props.componentTitle, props.navigationItems[selectedIndex.value]?.title || ''];
});
</script>

<style lang="scss" scoped>
.settings-layout {
    height: 100%;
    min-height: 427px;
    max-height: 550px;
    display: flex;
    flex-direction: column;
}

.settings-grid {
    display: grid;
    grid-template-columns: minmax(200px, 1fr) 2fr;
    width: 100%;
    height: 100%;
    flex: 1;

    @media (max-width: 600px) {
        grid-template-columns: 1fr;
        grid-template-rows: auto 1fr;
    }
}

.settings-sidebar {
    background-color: #fafafa;
    padding: 8px 8px;
}

.settings-content {
    background-color: white;
    display: grid;
    grid-template-rows: auto 1fr;
    padding: 14px 0 0 0;
}

.settings-component {
    overflow-y: auto;
    padding: 0 16px 16px 16px;
}

.settings-list {
    padding: 0;
    font-size: 14px;
    background-color: transparent !important;
}

.v-toolbar-title {
    .v-toolbar-title__placeholder {
        overflow: visible;
    }
}

.toolbar-settings {
    border-bottom: 1px solid #e0e0e0;
}
</style>
